import React, { Suspense } from 'react';
import { IMatchFormations } from '@sky-it-livedata/livedata-sports-design-system';

import { validateModel } from '../../utils/props-validator';
import { IComponentModel } from '../../typings/common-types';
import HtmlWrapper from '../html-wrapper/html-wrapper';

const MatchLineupsWrapper = React.lazy(() => import('./match-lineups'));
export interface IDynamicMatchLineupsWrapper extends IComponentModel<IMatchFormations> {
  live?: boolean;
  model: any;
}

const DynamicMatchLineups = ({
  /* istanbul ignore next: default value on mandatory field */ model = {},
  /* istanbul ignore next: default value */ query = {},
  /* istanbul ignore next: default value */ children = null,
  live = false,
}: IDynamicMatchLineupsWrapper) => (
  <Suspense fallback={<HtmlWrapper html={children} />}>
    <MatchLineupsWrapper
      initialModel={validateModel(model) as IMatchFormations}
      query={validateModel(query)}
      live={live}
    />
  </Suspense>
);

DynamicMatchLineups.defaultProps = {
  live: false,
};

export default DynamicMatchLineups;
